import {Injectable} from '@angular/core'
import {ConverterService, OccEndpointsService, PRODUCT_REFERENCES_NORMALIZER, ProductReference} from '@spartacus/core'
import {HttpClient} from '@angular/common/http'
import {MbFeaturedProductAdapter} from '../connectors'

@Injectable({
  providedIn: 'root'
})
export class MbOccFeaturedProductsAdapter implements MbFeaturedProductAdapter {

  constructor (protected http: HttpClient,
               protected occEndpoints: OccEndpointsService,
               protected converter: ConverterService,
               ) {
  }

  load (): any {
    return this.http
      .get<ProductReference[]>(this.getEndpoint())
      .pipe(this.converter.pipeable(PRODUCT_REFERENCES_NORMALIZER));
  }

  protected getEndpoint () {
    return this.occEndpoints.buildUrl('recommendedProducts')
  }

}
